import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="print"
export default class extends Controller {
  
  dismiss(e) {
    this.element.parentElement.remove()
  }  
  
}
